import { dispatch } from "../store/store";

import {
  setIsPharmacyServiceLoading,
  setIsPharmacyServiceSidebarLoading,
  setIsPharmacyServicesAnalyticsLoading,
  setIsServiceProgressLoading,
  resetPharmacyServiceState,
  setIsCalenderShow,
  resetDefaultCalenderAppointmentPharmacyServices,
  resetServiceUsersByCompany,
  setSidebarVisibleData,
  setCompletedServiceTabValueData,
  setSelectedRow,
  setServiceId,
  setServiceData,
  setNHSCount,
  setPrivateCount,
  setTotalCount,
  setServiceName,
  setServiceIcon,
  setServiceBuilderType,
  setNewClinicComponent,
  setCurrentEvents,
  setServiceAnalytics,
  setCurrentServiceTabValue,
  getPharmacyServiceData,
  getPharmacyClinicalServiceData,
  getPharmacyClinicalServiceCountData,
  getAnalyticsByServicePharmacyDateData,
  updateEventData,
  updateCalendarEventByClinicalServiceIdData,
  updateRecheduleByClinicalServiceIdData,
  getEventsData,
  getPharmaciesByCompanyIdData,
  getPharmacyByPharmacyIdData,
  getClinicalServiceBuilderByServiceIdData,
  getClinicalServiceByCompanyAndServiceIdData,
  setCalendarStartDate,
  setCalendarEndDate,
  setCalendarDates,
  addpharmacyServiceData,
  sendSMSData,
  setSmsQueue,
  getSMSData,
  getIdentityVerificationData,
  getIdentityVerificationDataBySessionIdData,
  checkYotiDataBySessionIdData,
  getOrbitSessionDetailData,
  saveOrbitSessionDetailData,
  getUserLogData,
  setNmsProgress,
  savePatientContactData,
  setPatientContact,
  setContactServiceId,
  setFilterPatient,
  setFilterNmsValues,
  setFilterTagsvalues,
  setFilterNamevalues,
  setPharmacyServices,
  sortPharmacyServicesByStage,
  setIsFilterModal,
  setScrollPositionData,
  setOpenData,
  setAnalyticsTabsValueData,
  setServiceProgressData,
  getServiceProgressData,
  updateClaimStatusData,
  sendToOrbitData,
  setOrbitQueue,
  setSentToOrbitData,
  changeSentToOrbitData,
  setOrbitClinicalServiceIdData,
  moveInterventionData,
  declineServicesData,
  rescheduleServicesData,
  setInterventionQueue,
  setDeclineQueue,
  setRescheduleQueue,
  setPdsQueue,
  setPatientNameValues,
  setFilterTagsvaluesConsented,
  setInterventionStageScrollPositionData,
  setEligibilityStageScrollPositionData,
  setListViewGridScrollPositionData,
  setShowRescheduleData,
  setCheckedAllEligibleData,
  setCheckedAllFollowUpData,
  setCheckedAllInterventionData,
  setCheckedAllConsentData,
  setProcessedPDSServicesData,
  setDrugFilterValueData,
  setSendSMSAutomationData,
  setSendOrbitAutomationData,
  setTransformedPharmacyData,
  getPharmacyActionsData,
  changePharmacyActionsData,
  moveDeclineServiceToClinicalServiceData,
  setSendInterventionAutomationData,
  getServiceTitanPatientPdsData,
  setFilteredPharmacyServicesData,
  setOriginalPharmacyServicesData,
  getDefaultCompanyServiceUrlData,
  getDefaultServicesByCompanyIdAndPharmacyIdData,
  getUsersByServiceCompanyPharmacyIDData,
  getAvailablePharmacistsForServiceData,
  getPharmacyAvailableSlotsData,
  getActivePharmacistsData,
  getPharmacyDefaultCheckListData,
  getClinicalServiceBuilderByIdData,
  getServiceTemplatesData,
  setTemplateControlValue,
  submitCustomTemplateData,
  setAnyControlChecked,
  getClinicalServiceBuilderByCompanyIdData,
  updateClinicalServicePaymentDetailsData,
  setSelectedClinicalServiceIdData,
  setShowPaymentModalData,
  setShowConsultationPageData,
  setSendToInterventionOptionsData,
  setIsAutomationMenuOpenData,
  setSendConsentOnlyData,
  setOrbitSendModal,
  setDeclineModal,
  setDeclineModalQueueData,
  getAgencyRatesData,
  getAgencyPharmacyData,
  addAgencyPharmacyData,
  setOrbitModalQueueData,
  getAnalyticsNMSProcessedData,
  getAnalyticsServicesEarningsData,
  getAnalyticsServicesUsersData,
  getAnalyticsServicesStagesData,
  getAnalyticsServicesCompletedClaimedData,
  getAnalyticsServicesCompletedToBeClaimedData,
  getAnalyticsServicesDeclinedData,
  setServiceTypeData,
  setCurrentServieIdData,
  addDayToServiceAvailability,
  removeDayFromServiceAvailability,
  updateSlotTimes,
  addNewSlot,
  removeSlot,
  duplicateSlot,
  setCurrentCompletedServiceValue,
  sendToAgencyOrbitData,
  getDoseShortCodeListData,
  updatePharmacyLocationData,
  getRoomsData,
  getUsersByServiceIDData,
  getAnalyticsServicesCompletedToBeClaimedHistoricalData,
  getHistoryAnalyticsNMSProcessedData,
  getHistoryAnalyticsServicesCompletedClaimedData,
  getNHSEmergencyServiceData,
  setShowNHSEmergencyKanbanData,
  getRoomsForAppointmentData,
  setAppointmentRoomsData,
  getPharmacyContactDetailsData,
  getPatientForNHSEmergencyServiceData,
  setMatchDialogModalData,
  setMatchPatientData,
  updateConsultationForPatientMatchData,
  updateConsultationStageData,
  setIsYotiSuccess,
  getServiceQRCheckListData,
  duplicateServiceData,
  setShowNHS111ReferralTabData,
  getReferralDataByConsultationIdData,
  recomputeNHSEmergencyOverdue,
} from "../features/pharmacyServiceSlice/pharmacyServiceSlice";
import { logErrorWithPayload } from "../services/logService";

const reducerName = "pharmacyService";

// #region State Setters
export const setShowCalender = (isCalender) => {
  dispatch(setIsCalenderShow(isCalender));
};
export const clearDefaultCalenderAppointmentPharmacyServices = () => {
  dispatch(resetDefaultCalenderAppointmentPharmacyServices());
};
export const clearServiceUsersByCompany = () => {
  dispatch(resetServiceUsersByCompany());
};
export const setSidebarVisible = (isSidebar) => {
  dispatch(setSidebarVisibleData(isSidebar));
};
export const setCompletedServiceTabValue = (value) => {
  dispatch(setCompletedServiceTabValueData(value));
};

export const updateControlCheckedState = (isChecked) => {
  dispatch(setAnyControlChecked(isChecked));
};
export const setSelectedRowData = (data) => {
  dispatch(setSelectedRow(data));
};
export const setShowPaymentModal = (data) => {
  dispatch(setShowPaymentModalData(data));
};
export const setShowConsultationPage = (data) => {
  dispatch(setShowConsultationPageData(data));
};
export const setSelectedClinicalServiceId = (id) => {
  dispatch(setSelectedClinicalServiceIdData(id));
};
export const setIsNewClinicComponent = (isNew) => {
  dispatch(setNewClinicComponent(isNew));
};

export const setCurrentServiceId = (serviceId) => {
  dispatch(setServiceId(serviceId));
};

export const setCurrentServiceIcon = (serviceIcon) => {
  dispatch(setServiceIcon(serviceIcon));
};

export const setCurrentServiceBuilderType = (serviceBuilderType) => {
  dispatch(setServiceBuilderType(serviceBuilderType));
};

export const setCurrentServiceName = (serviceName) => {
  dispatch(setServiceName(serviceName));
};

export const setCurrentServiceData = (serviceData) => {
  dispatch(setServiceData(serviceData));
};

export const setCurrentNHSCount = (NhsCount) => {
  dispatch(setNHSCount(NhsCount));
};

export const setCurrentPrivateCount = (privateCount) => {
  dispatch(setPrivateCount(privateCount));
};

export const setCurrentTotalServicesCount = (totalCount) => {
  dispatch(setTotalCount(totalCount));
};

export const setCurrentEvent = (events) => {
  dispatch(setCurrentEvents(events));
};

export const setCurrentServiceAnalytics = (analytics) => {
  dispatch(setServiceAnalytics(analytics));
};

export const resetPharmacyService = () => {
  dispatch(resetPharmacyServiceState());
};

export const setPharmacyServiceLoading = (isLoading) => {
  dispatch(setIsPharmacyServiceLoading(isLoading));
};

export const setPharmacyServiceSidebarLoading = (isLoading) => {
  dispatch(setIsPharmacyServiceSidebarLoading(isLoading));
};

export const setPharmacyServicesAnalyticsLoading = (isLoading) => {
  dispatch(setIsPharmacyServicesAnalyticsLoading(isLoading));
};

export const setServiceProgressLoading = (isLoading) => {
  dispatch(setIsServiceProgressLoading(isLoading));
};

export const setCurrentNmsProgress = (data) => {
  dispatch(setNmsProgress(data));
};

export const setCurrentPatientContact = (data) => {
  dispatch(setPatientContact(data));
};

export const setCurrentContactServiceId = (data) => {
  dispatch(setContactServiceId(data));
};

export const setServiceTab = (tabValue = 0) => {
  dispatch(setCurrentServiceTabValue(tabValue));
};

export const setCurrentCalendarStartDate = (date) => {
  const strDate = date instanceof Date ? date.toISOString() : date;
  dispatch(setCalendarStartDate(strDate));
};

export const setCurrentCalendarEndDate = (date) => {
  const strDate = date instanceof Date ? date.toISOString() : date;
  dispatch(setCalendarEndDate(strDate));
};

export const setCurrentCalendarDates = (startDate, endDate) => {
  const strStartDate =
    startDate instanceof Date ? startDate.toISOString() : startDate;
  const strEndDate = endDate instanceof Date ? endDate.toISOString() : endDate;
  dispatch(setCalendarDates(strStartDate, strEndDate));
};

export const setFilterPatientData = (filterData) => {
  dispatch(setFilterPatient(filterData));
};
export const setFilterNmsData = (filterData) => {
  dispatch(setFilterNmsValues(filterData));
};
export const setFilterTagsData = (filterData) => {
  dispatch(setFilterTagsvalues(filterData));
};
export const setFilterTagsConsentedData = (filterData) => {
  dispatch(setFilterTagsvaluesConsented(filterData));
};
export const setFilterNameData = (filterData) => {
  dispatch(setFilterNamevalues(filterData));
};
export const setOriginalPharmacyServices = (filterData) => {
  dispatch(setOriginalPharmacyServicesData(filterData));
};
export const setCurrentPharmacyServices = (data) => {
  dispatch(setPharmacyServices(data));
};
export const sortServicesStage = (stageNo, ascending) => {
  dispatch(sortPharmacyServicesByStage({ stageNo, ascending }));
};
export const setCurrentFilterModal = (data) => {
  dispatch(setIsFilterModal(data));
};
export const setOpen = (data) => {
  dispatch(setOpenData(data));
};

export const setPatientNameData = (filterData) => {
  dispatch(setPatientNameValues(filterData));
};
export const setAppointmentRooms = (data) => {
  dispatch(setAppointmentRoomsData(data));
};

export const setMatchDialogModal = (data) => {
  dispatch(setMatchDialogModalData(data));
};

export const setMatchPatient = (data) => {
  dispatch(setMatchPatientData(data));
};

export const setServicesNameAndIcons = async (
  serviceName,
  serviceIcon,
  serviceBuilderType,
) => {
  setCurrentServiceName(serviceName);
  setCurrentServiceIcon(serviceIcon);
  setCurrentServiceBuilderType(serviceBuilderType);
  setIsNewClinicComponent(false);
};

export const setCurrentSmsQueue = (sms) => {
  dispatch(setSmsQueue([...sms]));
};

export const setCurrentOrbitQueue = (orbit) => {
  dispatch(setOrbitQueue([...orbit]));
};

export const setScrollPosition = (value = 0) => {
  dispatch(setScrollPositionData(value));
};
export const setAnalyticsTabsValue = (value = 0) => {
  dispatch(setAnalyticsTabsValueData(value));
};
export const setServiceProgressValue = (value = 0) => {
  dispatch(setServiceProgressData(value));
};
export const setSentToOrbit = (data) => {
  dispatch(setSentToOrbitData(data));
};
export const setOrbitClinicalServiceId = (data) => {
  dispatch(setOrbitClinicalServiceIdData(data));
};
export const setCurrentInterventionQueue = (value) => {
  dispatch(setInterventionQueue([...value]));
};
export const setCurrentDeclineQueue = (value) => {
  dispatch(setDeclineQueue([...value]));
};
export const setCurrentRescheduleQueue = (value) => {
  dispatch(setRescheduleQueue([...value]));
};
export const setCurrentPdsQueue = (value) => {
  dispatch(setPdsQueue([...value]));
};
export const setInterventionStageScrollPosition = (value = 0) => {
  dispatch(setInterventionStageScrollPositionData(value));
};
export const setEligibilityStageScrollPosition = (value = 0) => {
  dispatch(setEligibilityStageScrollPositionData(value));
};
export const setListViewGridScrollPosition = (value = 0) => {
  dispatch(setListViewGridScrollPositionData(value));
};
export const setShowReschedule = (value = 0) => {
  dispatch(setShowRescheduleData(value));
};
export const setCheckedAllEligible = (value = false) => {
  dispatch(setCheckedAllEligibleData(value));
};
export const setCheckedAllFollowUp = (value = false) => {
  dispatch(setCheckedAllFollowUpData(value));
};
export const setCheckedAllIntervention = (value = false) => {
  dispatch(setCheckedAllInterventionData(value));
};
export const setCheckedAllConsent = (value = false) => {
  dispatch(setCheckedAllConsentData(value));
};
export const setProcessedPDSServices = (value) => {
  dispatch(setProcessedPDSServicesData(value));
};
export const setDrugFilterValue = (value) => {
  dispatch(setDrugFilterValueData(value));
};
export const setSendSMSAutomation = (value) => {
  dispatch(setSendSMSAutomationData(value));
};
export const setSendOrbitAutomation = (value) => {
  dispatch(setSendOrbitAutomationData(value));
};
export const setSendConsentOnly = (value) => {
  dispatch(setSendConsentOnlyData(value));
};
export const setTransformedPharmacies = (value) => {
  dispatch(setTransformedPharmacyData(value));
};
export const setSendInterventionAutomation = (value) => {
  dispatch(setSendInterventionAutomationData(value));
};
export const setFilteredPharmacyServices = (value) => {
  dispatch(setFilteredPharmacyServicesData(value));
};
export const setShowNHSEmergencyKanban = (value) => {
  dispatch(setShowNHSEmergencyKanbanData(value));
};
export const setShowNHS111ReferralTab = (value) => {
  dispatch(setShowNHS111ReferralTabData(value));
};
export const recomputeOverdueColumns = () => {
  dispatch(recomputeNHSEmergencyOverdue());
};

export const updateTemplateControlValue = (
  templateIndex,
  sectionIndex,
  controlIndex,
  value,
) => {
  dispatch(
    setTemplateControlValue({
      templateIndex,
      sectionIndex,
      controlIndex,
      value,
    }),
  );
};
export const setSendToInterventionOptions = (value) => {
  dispatch(setSendToInterventionOptionsData(value));
};
export const setIsAutomationMenuOpen = (value) => {
  dispatch(setIsAutomationMenuOpenData(value));
};
export const setOrbitSend = (data) => {
  dispatch(setOrbitSendModal(data));
};
export const setCurrentDeclineModal = (data) => {
  dispatch(setDeclineModal(data));
};
export const setOrbitModalQueue = (value) => {
  dispatch(setOrbitModalQueueData([...value]));
};
export const setDeclineModalQueue = (value) => {
  dispatch(setDeclineModalQueueData([...value]));
};
export const setServiceType = (value) => {
  dispatch(setServiceTypeData(value));
};
export const setCurrentPharmacyServiceId = (value) => {
  dispatch(setCurrentServieIdData(value));
};

export const setCurrentCompletedService = (value) => {
  dispatch(setCurrentCompletedServiceValue(value));
};

export const setYotiSuccess = (value) => {
  dispatch(setIsYotiSuccess(value));
};

export const addDayToSelectedService = (pharmacyId, serviceId, newDay) => {
  try {
    dispatch(
      addDayToServiceAvailability({ pharmacyId, serviceId, day: newDay }),
    );
  } catch (error) {
    console.error("Error adding day:", error);
  }
};

export const removeDayFromSelectedService = (
  pharmacyId,
  serviceId,
  dayOfWeek,
) => {
  try {
    dispatch(
      removeDayFromServiceAvailability({ pharmacyId, serviceId, dayOfWeek }),
    );
  } catch (error) {
    console.error("Error removing day:", error);
  }
};

// In your pharmacyServiceDispatchers.js file
export const updateSlots = (pharmacyId, serviceId, dayOfWeek, updatedSlots) => {
  try {
    dispatch(
      updateSlotTimes({ pharmacyId, serviceId, dayOfWeek, updatedSlots }),
    );
  } catch (error) {
    console.error("Error updating slots:", error);
  }
};

export const addSlot = (pharmacyId, serviceId, dayOfWeek) => {
  try {
    dispatch(
      addNewSlot({
        pharmacyId,
        serviceId,
        dayOfWeek,
      }),
    );
  } catch (error) {
    console.error("Error adding slot:", error);
  }
};

export const deleteSlot = (pharmacyId, serviceId, dayOfWeek, slotIndex) => {
  try {
    dispatch(
      removeSlot({
        pharmacyId,
        serviceId,
        dayOfWeek,
        slotIndex,
      }),
    );
  } catch (error) {
    console.error("Error deleting slot:", error);
  }
};

export const copySlot = (pharmacyId, serviceId, dayOfWeek, slotIndex) => {
  try {
    dispatch(
      duplicateSlot({
        pharmacyId,
        serviceId,
        dayOfWeek,
        slotIndex,
      }),
    );
  } catch (error) {
    console.error("Error copying slot:", error);
  }
};

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers
export const getClinicalServiceBuilderByCompanyId = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getClinicalServiceBuilderByCompanyIdData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

export const getPharmacyServices = async (
  pharmacyId,
  searchType = 0,
  serviceId = 0,
  showCalender = false,
) => {
  let result = [];
  try {
    setCurrentServiceId(serviceId);
    setShowCalender(showCalender);
    result = await dispatch(
      getPharmacyServiceData({
        pharmacyId,
        searchType,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getPharmacyClinicalServices = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPharmacyClinicalServiceData(pharmacyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }

  return result;
};

export const getPharmacyClinicalServicesCount = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPharmacyClinicalServiceCountData(pharmacyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }

  return result;
};

export const getServiceAnalytics = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsByServicePharmacyDateData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getEvents = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(getEventsData({ pharmacyId, serviceId })).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const getClinicalServiceBuilders = async (pharmacyId, serviceId = 0) => {
  let result = [];
  try {
    result = await dispatch(
      getClinicalServiceBuilderByServiceIdData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getClinicalServicebyServiceCompanyId = async (
  companyID,
  serviceID,
) => {
  let result = [];
  try {
    result = await dispatch(
      getClinicalServiceByCompanyAndServiceIdData({
        companyID,
        serviceID,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getPharmaciesByCompanyId = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getPharmaciesByCompanyIdData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = [];
  }
  return result;
};
export const getPharmacyByPharmacyId = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(getPharmacyByPharmacyIdData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);

    result = [];
  }
  return result;
};

export const addpharmacyService = async (pharmacyId, data) => {
  let result = null;
  try {
    result = await dispatch(
      addpharmacyServiceData({ pharmacyId, data }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updateEvent = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateEventData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const updateCalendarEventByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      updateCalendarEventByClinicalServiceIdData(params),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};
export const updateRecheduleByClinicalServiceId = async (params) => {
  let result = null;
  try {
    result = await dispatch(
      updateRecheduleByClinicalServiceIdData(params),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);

    result = null;
  }
  return result;
};

export const sendSMS = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendSMSData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updateClaimStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateClaimStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const sendToOrbit = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendToOrbitData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const sendToAgencyOrbit = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendToAgencyOrbitData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getSMS = async () => {
  let result = [];
  try {
    result = await dispatch(getSMSData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const getIdentityVerification = async () => {
  let result = [];
  try {
    result = await dispatch(getIdentityVerificationData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const getIdentityVerificationDataBySessionId = async (
  sessionId,
  gphcNumber,
) => {
  let result = [];
  try {
    result = await dispatch(
      getIdentityVerificationDataBySessionIdData({ sessionId, gphcNumber }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const checkYotiDataBySessionId = async (sessionId) => {
  let result = [];
  try {
    result = await dispatch(checkYotiDataBySessionIdData(sessionId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, sessionId);

    result = [];
  }
  return result;
};

export const getOrbitSessionDetail = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(getOrbitSessionDetailData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);

    result = [];
  }
  return result;
};
export const changeSentToOrbit = async (serviceId) => {
  let result = [];
  try {
    result = await dispatch(changeSentToOrbitData(serviceId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, serviceId);

    result = [];
  }
  return result;
};

export const saveOrbitSessionDetail = async (data) => {
  let result = null;
  try {
    result = await dispatch(saveOrbitSessionDetailData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getUserLog = async (serviceId) => {
  let result = [];
  try {
    result = await dispatch(getUserLogData(serviceId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, serviceId);

    result = [];
  }
  return result;
};

export const savePatientContact = async (serviceId, telephone, data) => {
  let result = null;
  try {
    result = await dispatch(
      savePatientContactData({ serviceId, telephone, data }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getServiceProgress = async (serviceId, pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(
      getServiceProgressData({ serviceId, pharmacyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const getPharmacyActions = async (params) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyActionsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }

  return result;
};

export const changePharmacyActions = async (
  pharmacyId,
  pharmacyActionType,
  isAction,
) => {
  let result = null;
  try {
    result = await dispatch(
      changePharmacyActionsData({ pharmacyId, pharmacyActionType, isAction }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const moveDeclineServiceToClinicalService = async (
  clinicalServiceId,
) => {
  let result = null;
  try {
    result = await dispatch(
      moveDeclineServiceToClinicalServiceData(clinicalServiceId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, clinicalServiceId);
    result = null;
  }

  return result;
};

export const moveIntervention = async (data) => {
  let result = null;
  try {
    result = await dispatch(moveInterventionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const declineServices = async (data) => {
  let result = null;
  try {
    result = await dispatch(declineServicesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const rescheduleServices = async (data) => {
  let result = null;
  try {
    result = await dispatch(rescheduleServicesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getServiceTitanPatientPds = async (params) => {
  let result = null;
  try {
    result = await dispatch(getServiceTitanPatientPdsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = null;
  }
  return result;
};

export const getDefaultCompanyServices = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getDefaultCompanyServiceUrlData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);

    result = [];
  }
  return result;
};

export const getDefaultServicesByCompanyIdAndPharmacyId = async (params) => {
  let result = [];
  try {
    result = await dispatch(
      getDefaultServicesByCompanyIdAndPharmacyIdData(params),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }
  return result;
};

export const getDefaultCompanyCheckList = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(
      getPharmacyDefaultCheckListData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = null;
  }
  return result;
};

export const getQRServiceCheckList = async (
  companyId,
  serviceId,
  pharmacyId,
) => {
  let result = null;
  try {
    // result = await dispatch(
    //   getServiceQRCheckListData(companyId,serviceId,pharmacyId),
    // ).unwrap();
    result = await dispatch(
      getServiceQRCheckListData({
        companyId: companyId,
        serviceId: serviceId,
        pharmacyId: pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, companyId);
    result = null;
  }
  return result;
};

export const duplicateService = async (serviceId, companyId) => {
  let result = null;
  try {
    result = await dispatch(
      duplicateServiceData({ serviceId, companyId }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, { serviceId, companyId });
    result = null;
  }
  return result;
};

export const getClinicalServiceBuilderById = async (serviceId) => {
  let result = null;
  try {
    result = await dispatch(
      getClinicalServiceBuilderByIdData(serviceId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, serviceId);

    result = null;
  }
  return result;
};

export const getServiceTemplates = async (data) => {
  let result = null;
  try {
    result = await dispatch(getServiceTemplatesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const submitCustomServiceTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(submitCustomTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updateClinicalServicePaymentDetails = async (
  clinicalServiceId,
  isPaymentTaken,
) => {
  let result = null;
  try {
    result = await dispatch(
      updateClinicalServicePaymentDetailsData(
        clinicalServiceId,
        isPaymentTaken,
      ),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};

export const addAgencyPharmacy = async (data) => {
  let result = null;
  try {
    result = await dispatch(addAgencyPharmacyData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getAgencyRates = async () => {
  let result = null;
  try {
    result = await dispatch(getAgencyRatesData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = null;
  }
  return result;
};

export const getAgencyPharmacy = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getAgencyPharmacyData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);

    result = null;
  }
  return result;
};

export const getAnalyticsNMSProcessed = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsNMSProcessedData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesEarnings = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesEarningsData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesUsers = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesUsersData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesStages = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesStagesData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesCompletedClaimed = async (
  pharmacyId,
  serviceId,
) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesCompletedClaimedData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesCompletedToBeClaimed = async (
  pharmacyId,
  serviceId,
  filterType,
) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesCompletedToBeClaimedData({
        pharmacyId,
        serviceId,
        filterType,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesDeclined = async (pharmacyId, serviceId) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesDeclinedData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getDoseShortCodeList = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getDoseShortCodeListData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = null;
  }

  return result;
};

export const UpdatePharmacyLocation = async (params) => {
  let result = null;
  try {
    result = await dispatch(updatePharmacyLocationData(params)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};
export const getRooms = async (params) => {
  let result = null;
  try {
    result = await dispatch(getRoomsData(params)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const getUsersByServiceID = async (serviceID, companyId, pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getUsersByServiceIDData({
        serviceID,
        companyId,
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getUsersByServiceCompanyPharmacyID = async (
  companyId,
  serviceId,
  pharmacyId,
) => {
  let result = [];
  try {
    result = await dispatch(
      getUsersByServiceCompanyPharmacyIDData({
        companyId,
        serviceId,
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};
export const getAvailablePharmacistsForService = async (companyId, serviceId, pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getAvailablePharmacistsForServiceData({
        companyId,
        serviceId,
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getPharmacyAvailableSlots = async (data) => {
  let result = [];
  try {
    result = await dispatch(getPharmacyAvailableSlotsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = [];
  }

  return result;
};

export const getActivePharmacists = async (data) => {
  let result = [];
  try {
    result = await dispatch(getActivePharmacistsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = [];
  }

  return result;
};

export const getAnalyticsServicesCompletedToBeClaimedHistorical = async (
  pharmacyId,
  serviceId,
  filterType,
) => {
  let result = [];
  try {
    result = await dispatch(
      getAnalyticsServicesCompletedToBeClaimedHistoricalData({
        pharmacyId,
        serviceId,
        filterType,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getHistoricalAnalyticsNMSProcessed = async (
  pharmacyId,
  serviceId,
) => {
  let result = [];
  try {
    result = await dispatch(
      getHistoryAnalyticsNMSProcessedData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getHistoryAnalyticsServicesCompletedClaimed = async (
  pharmacyId,
  serviceId,
) => {
  let result = [];
  try {
    result = await dispatch(
      getHistoryAnalyticsServicesCompletedClaimedData({
        pharmacyId,
        serviceId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getNHSEmergencyService = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(getNHSEmergencyServiceData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getRoomsForAppointment = async (data) => {
  let result = [];
  try {
    result = await dispatch(getRoomsForAppointmentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getPatientForNHSEmergencyService = async (consultationId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientForNHSEmergencyServiceData(consultationId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }

  return result;
};

export const getPharmacyContactDetails = async (pharmacyId) => {
  let result = null;
  try {
    result = await dispatch(getPharmacyContactDetailsData(pharmacyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

export const updateConsultationForPatientMatch = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      updateConsultationForPatientMatchData({ data }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updateConsultationStage = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsultationStageData({ data })).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getReferralDataByConsultationId = async (consultationId) => {
  let result = null;
  try {
    result = await dispatch(
      getReferralDataByConsultationIdData(consultationId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }

  return result;
};

// #endregion
